import React , {useEffect, useState} from 'react'
import AOS from "aos";
import "aos/dist/aos.css";
import "animate.css";
import consultation from '../assets/DocImages/001 (1).png'
import shape from '../assets/Images/shapes/appointmentThread-01.png'
import { Link } from 'react-router-dom';
import BookAppointmentDialog from './BookAnAppointmentDialogue'
export default function Appointment () {
  const [dialogOpen, setDialogOpen] = useState(false);
  const handleOpenDialog = () => {
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };
  useEffect(() => {
    AOS.init({
      duration: 1000, 
      once: true, 
    });
  }, []);
  return (
    <div className='overflow-hidden'>
      <div className='max-w-[1340px] mx-auto pl-[24px] md:pl-[24px] xl:pl-[0px]'>
        <div className='relative'>
          {/* Background Shape (Behind Content) */}
          <div className='absolute inset-y-0 left-0 w-screen h-full bg-verylightGreen rounded-tl-[24px] rounded-bl-[24px]  lg:ml-[6.3%] z-0 '></div>
          <div
            className='absolute max-w-[64%] inset-auto bottom-[-2%] left-[-10%] '
            style={{ opacity: 1 }}
          >
            <img
              src={shape}
              loading='eager'
              alt='Medical Appointment Line Left Shape Bg - Medic X Webflow Template'
              className='w-full h-auto animate__animated animate__fadeIn animate__delay-1s'
            />
          </div>
          {/* Content & Image (Ensure it stays above) */}
          <div className='relative z-1'>
            <div className='grid lg:grid-cols-[1fr_minmax(auto,525px)] gap-x-[40px] justify-between py-[100px] px-10 md:px-10 lg:px-0 items-center w-full mx-auto '>
              {/* Left Image Container */}
              <div className='rounded-[24px] overflow-hidden  max-w-full lg:max-w-[360px] xl:max-w-[460px]' data-aos="fade-up">
                <img
                  src={consultation}
                  alt='Virtual Medical Appointment - Medic X Webflow Template'
                  className='w-full object-cover'
                />
              </div>

              {/* Right Text Content */}
              <div> 
                <h2 className=' text-[32px] md:text-[58px] leading-[1.138em] font-heading text-thickGreen mt-4 md:mt-0  mb-[48px]'>
                Book Your Appointment Today
                </h2>
                <p className='text-[20px] font-[500] text-paraGreen leading-[1.667em] font-body mb-[40px] z-30'>
                Get exceptional care along with personalised treatment for a healthier future at MagnAid Hospitals by scheduling an appointment. 
                </p>

                {/* Buttons */}
                <div className='sm:block md:flex md:space-x-4 space-y-4 md:space-y-0'>
                  <button
                    onClick={handleOpenDialog}
                    className='bg-orange text-white w-full md:w-[50%] px-6 py-6 rounded-full font-body text-[20px] leading-[1.112em] 
             transition-all duration-300 hover:bg-lightGreen font-medium   hover:bg-opacity-90 
             hover:translate-y-[-3px] block md:inline-block  text-center'
                  >
                    Book an Appointment
                  </button>

                  <Link
                    to='/our-medical-services'
                    className='text-thickGreen w-full md:w-[50%] px-6 py-6 rounded-full hover:bg-orange  font-body font-medium border border-thickGreen bg-transparent flex justify-center items-center  hover:border-none hover:text-white text-[20px] leading-[1.112em]  transition-all duration-300 hover:translate-y-[-3px]'
                  >
                    Our Services
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <BookAppointmentDialog open={dialogOpen} onClose={handleCloseDialog} />
    </div>
  )
}
